// extracted by mini-css-extract-plugin
export default {"cls1":"RqBidPe0X7A774ox2IFn","cls2":"RaQSdeuzBkIRpNIUj8Qq RqBidPe0X7A774ox2IFn"};